import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { AttachmentImage, UserId, Uuid } from '../Base';
import { RepositoryElement } from '../Repository';
import { I18nClassroomInfo } from './Space';

interface LeaderboardParticipants {
  [leaderboardId: string]: number;
}

interface Statistics {
  lessonCount: number | null;
  challengeCount: number | null;
  practiceCount: number | null;
  itemCount: number | null;
  gameCount: number | null;
  multiplayerGameCount: number | null;
  slideshowCount: number | null;
  partPracticeCount: number | null;
  miniPracticeCount: number | null;
  memberCount: number | null;
  teamCount: number | null;
  regionCount: number | null;
  rewardOfferCount: number | null;
  gameSetCount: number | null;
}

interface BandPercentages {
  band1: number;
  band2: number;
  band3: number;
}

interface TeamSettings {
  teamSize?: number;
}

export interface LeaderboardJson<T = number> {
  readonly leaderboardId: Uuid; //identifier
  classroomId: Uuid;
  startedAt: T;
  endedAt: T;

  notificationSentAt?: T;
  finalizationStartedAt?: T;
  finalizationEndedAt?: T;
  i18nLeaderboardInfo: I18nClassroomInfo;
  gameSetIds: Uuid[];
  statistics: Statistics;
  finalized?: number;
  bandPercentages: BandPercentages;
  teamSettings: TeamSettings;
}

export class Leaderboard
  extends RepositoryElement
  implements LeaderboardJson<Date>
{
  readonly leaderboardId!: Uuid;
  classroomId!: Uuid;
  startedAt!: Date;
  endedAt!: Date;

  notificationSentAt?: Date;
  finalizationStartedAt?: Date;
  finalizationEndedAt?: Date;
  i18nLeaderboardInfo!: I18nClassroomInfo;
  gameSetIds!: Uuid[];
  statistics!: Statistics;
  finalized?: number;
  bandPercentages!: BandPercentages;
  teamSettings!: TeamSettings;

  teamId!: Uuid;
  createdBy!: UserId;
  createdAt!: Date;
  lastModifiedAt!: Date;
  isSuspended?: boolean;
  name!: string;
  description!: null | string;
  icon!: AttachmentImage;
  leaderboardParticipants!: LeaderboardParticipants;

  constructor(spaceTeam: LeaderboardJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(spaceTeam));
  }

  id() {
    // Assuming the unique identifier for the Leaderboard is the leaderboardId
    return this.leaderboardId;
  }

  toJSON(): LeaderboardJson<number> {
    // Convert the class instance back to a JSON object
    // The type assertion should match the generic type of the interface
    return deepTransformDate(this) as unknown as LeaderboardJson<number>;
  }
}
